import { render } from "./TransportCostComplete.vue?vue&type=template&id=38198acb&scoped=true&ts=true"
import script from "./TransportCostComplete.vue?vue&type=script&lang=ts"
export * from "./TransportCostComplete.vue?vue&type=script&lang=ts"

import "./TransportCostComplete.vue?vue&type=style&index=0&id=38198acb&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-sakakibara\\Documents\\Git\\workflow-system\\workflow\\frontend\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38198acb"]])

export default __exports__